import { aplicacaoProva } from './aplicacaoProva';
import { minhasProvas } from './minhasProvas';
import { minhasQuestoesDiscursivas } from './minhasQuestoesDiscursivas';
import { minhasRedacoes } from './minhasRedacoes';
import { realizarProva } from './realizarProva';
import { uploadGabarito } from './uploadGabarito';
import { grupoAvaliacao } from './grupoAvaliacao';

export const gerenciamento = [...minhasProvas, ...minhasRedacoes, ...minhasQuestoesDiscursivas, ...aplicacaoProva, ...grupoAvaliacao, ...realizarProva, ...uploadGabarito];



// WEBPACK FOOTER //
// ./src/routes/prova/gerenciamento/index.js